import Vue from "vue";
import Router from "vue-router";

//components
import Users from "@/views/Users";
import TRegisters from "@/views/TRegisters";
import Tareo from "@/views/Tareo";
import Home from "@/views/Home";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "login",
      component: () => import("@/views/Login"),
    },
    {
      path: "/panel",
      name: "panel",
      component: () => import("@/views/Panel"),
      redirect: "/panel/home",

      children: [
        {
          path: "home",
          name: "Inicio",
          components: {
            panel: Home,
          },
          meta: {
            icon: "icon-home",
          },
        },
        {
          path: "t-registers",
          name: "T-Registros",
          redirect: "t-registers/borrador",
          components: {
            panel: TRegisters,
          },
          meta: {
            icon: "icon-files",
          },
          children: [
            {
              path: "borrador",
              name: "trDrafts",
              components: {
                "tregistros-view": () =>
                  import("../components/TRegisters/Draft.vue"),
              },
              meta: {
                parent: "T-Registros",
              },
            },
            {
              path: "habilitar",
              name: "trForEmployee",
              components: {
                "tregistros-view": () =>
                  import("../components/TRegisters/ForEmployee.vue"),
              },
              meta: {
                parent: "T-Registros",
              },
            },
            {
              path: "activos",
              name: "trHasEmployee",
              components: {
                "tregistros-view": () =>
                  import("../components/TRegisters/HasEmployee.vue"),
              },
              meta: {
                parent: "T-Registros",
              },
            },
            {
              path: "de-baja",
              name: "trDown",
              components: {
                "tregistros-view": () =>
                  import("../components/TRegisters/Down.vue"),
              },
              meta: {
                parent: "T-Registros",
              },
            },
          ],
        },
        {
          path: "empleados",
          redirect: { name: "Empleados-lista", query: { state: "active" } },
          name: "Empleados",
          components: {
            panel: Users,
          },
          meta: {
            icon: "icon-user",
          },
          children: [
            {
              path: "list",
              name: "Empleados-lista",
              components: {
                panel: Users,
                userView: () =>
                  import("../components/empleado/EmployeeListView.vue"),
              },
              meta: {
                parent: "Empleados",
              },
            },
            
          ],
        },
        {
          path: "empleados/:id",
          name: "active-employee",
          redirect: {name: 'personal-data'},
          components:{
            panel:  () => import("../components/empleado/EmployeeDetail.vue"),
          },
          children: [
            {
              path: "datos-personales",
              name: "personal-data",
              component: () =>
                  import("../components/empleado/Employee.vue"),
              meta: {
                parent: "Empleados",
              },
            },
            {
              path: "remuneraciones-fijas",
              name: "fixed-remuneration",
              component: () => import("../components/empleado/ConceptosRemunerativos.vue"),
              // components: {
              //   panel: Users,
              //   userView: () =>
              //     import("../components/empleado/EmployeeDetail.vue"),
              //   "enployee-view": () =>
              //     import("../components/empleado/ConceptosRemunerativos.vue"),
              // },
              meta: {
                parent: "Empleados",
              },
            },
            {
              path: "remuneraciones-variables",
              name: "var-remuneration",
              component: () =>
              import("../components/empleado/BonoComision.vue"),
              meta: {
                parent: "Empleados",
              },
            },
            {
              path: "descuentos",
              name: "deductions",
              component: () =>
              import("../components/empleado/Descuentos.vue"),
              meta: {
                parent: "Empleados",
              },
            },
            {
              path: "vacaciones-inicial",
              name: "init-vacation",
              component: () =>
              import("../components/empleado/VacationInitial.vue"),
              meta: {
                parent: "Empleados",
              },
            },
            {
              path: "historico",
              name: "historic-employee",
              component: () =>
              import("../components/empleado/History.vue"),
              meta: {
                parent: "Empleados",
              },
            },
          ],
          meta: {
            parent: "Empleados",
          },
        },
        {
          path: "liquidation/:id",
          name: "LiquidationDetail",
          components: {
            panel: () =>
              import("../components/empleado/EmployeeSettlement.vue"),
          },
          meta: {
            parent: "Empleados",
          },
        },
        {
          path: "tareo",
          name: "Tareo",
          components: {
            panel: Tareo,
          },
          meta: {
            icon: "icon-calendar",
          },
        },
        {
          path: "countings",
          name: "Cálculos",
          redirect: "countings/resumeMonthly",
          components: {
            panel: () => import("../views/Counting.vue"),
          },
          meta: {
            icon: "icon-counting",
          },
          children: [
            {
              path: "resumeMonthly",
              name: "resumeMonthly",
              components: {
                "counting-view": () =>
                  import("../components/countings/ResumeMonthly.vue"),
              },
              meta: {
                parent: "Cálculos",
              },
            },
            {
              path: "resumeYearly",
              name: "resumeYearly",
              components: {
                "counting-view": () =>
                  import("../components/countings/ResumeYearly.vue"),
              },
              meta: {
                parent: "Cálculos",
              },
            },
            {
              path: "pages/:id/:date",
              name: "countingPages",
              components: {
                "counting-view": () =>
                  import("../components/empleado/EmpSheet.vue"),
              },
              meta: {
                parent: "Cálculos",
              },
            },
          ],
        },
        {
          path: "plame",
          name: "plame",
          components: {
            panel: () => import("../views/Plame.vue")
          },
          meta: {
            icon: "icon-text"
          }
        },
        {
          path: "cts",
          name: "cts",
          components: {
            panel: () => import("../views/CTS.vue"),
          },
          meta: {
            icon: "icon-cts",
          },
        },
        {
          path: "cts-resumen/:id",
          name: "cts-doc",
          components: {
            panel: () => import("../components/cts/Settlement.vue"),
          },
          meta: {
            parent: "cts",
          },
        },
        {
          path: "vacations",
          name: "Vacaciones",
          redirect: {
            name: "VacationPage",
            query: { date: new Date().toISOString() },
          },
          components: { panel: () => import("../views/Vacations.vue") },
          meta: {
            icon: "icon-plane",
          },
          children: [
            {
              path: "empresa",
              name: "VacationPage",
              components: {
                "vacation-view": () =>
                  import("../components/vacations/ResumeVacations.vue"),
              },
              meta: {
                parent: "Vacaciones",
              },
            },
          ],
        },
        {
          path: "system-users",
          name: "Usuario de Sistema",
          components: { panel: () => import("../views/Admins.vue") },
          meta: {
            icon: "icon-master",
          },
        },
        // Oculto por ahora
        // {
        //   path: "business-users",
        //   name: "Usuario de Empresa",
        //   components: { panel: () => import("../views/BusinessUsers.vue") },
        //   meta: {
        //     icon: "icon-master",
        //   },
        // },
        {
          path: "business",
          name: "Empresas",
          components: { panel: () => import("../views/Business.vue") },
          meta: {
            icon: "icon-business",
          },
        },
        {
          path: "settings",
          name: "Configuración",
          components: { panel: () => import("@/views/Settings") },
          meta: {
            icon: "icon-setting",
          },
        },
        {
          path: "*",
          name: "errorhijo",
          components: { panel: () => import("@/components/Error") },
          meta: {
            icon: false,
          },
        },
      ],
    },
    {
      path: "*",
      name: "error",
      component: () => import("@/components/Error"),
    },
  ],
});
